import React, { Component } from "react";
import { connect } from "react-redux";
import { SearchIcon } from "@heroicons/react/solid";
import LocaleStrings from "../../../../languages";
import _ from "lodash";
import BaseLoader from "../../../../../common/base-loader";
import WordsListItems from "./wordlist-items";
import {
  fetchRestrictedWords,
  searchRestrictedwords,
} from "../../actions/index";
import AddRestrictedWords from "./addrestrictedwords";
import { NotificationContainer } from "react-notifications";
import Pagination from "react-js-pagination";
import AllGlobalTabsList from "../globaltabs";
import AddRestrictedFile from "./addrestrictedfile";
import { classNames } from "../../../../../common/common-functions";

class ContentManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveredorderSearch: "",
      loaderDesc: LocaleStrings.loaderDesc_content_management,
      loading: true,
      pageNumber: 1,
      search: "",
    };

    // All Binded Functions
  }

  componentDidMount() {
    this.props.fetchRestrictedWords(
      this.props.session,
      0,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }
  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchRestrictedWords(
        this.props.session,
        0,
        (CallBackResponse) => {}
      );
    } else {
      this.props.searchRestrictedwords(this.props.session, search);
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    //  console.log("pgno", pageNumber)
    if (this.state.search == "") {
      this.props.fetchRestrictedWords(
        this.props.session,
        pageNumber,
        (response) => {}
      );
    } else {
      this.props.searchRestrictedwords(
        this.props.session,
        this.state.search,
        pageNumber
      );
    }

    this.setState({ ...this.state, pageNumber });
  };

  renderwordList() {
    // let searchText = this.state.deliveredorderSearch;
    // let filtered = [];

    // if (this.state.deliveredorderSearch !== "") {
    //   // If Search Key Found
    //   let listing = this.props.allAddListing.data;

    //   filtered = _.filter(listing, function (o) {
    //     return (
    //       o.product.invoice_no.toLowerCase().indexOf(_.toLower(searchText)) > -1
    //     );
    //   });
    // } else {
    //   filtered = this.props.globalRestrictedWords.data;
    // }
    let pageDataLength = this.props.globalRestrictedWords.data.length;

    let { pageNumber } = this.state;

    var items = _.map(this.props.globalRestrictedWords.data, (values) => (
      <WordsListItems
        key={values.userid}
        values={values}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    return items;
  }

  render() {
    let { language } = this.props;
    return (
      <>
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <>
            <AllGlobalTabsList history={this.props.history} />
            <div
              className="grid gap-4 grid-rows-1  md:grid-rows-3 sm:grid-rows-3 lg:grid-rows-1 m-6"
              style={{
                overflowX: "hidden",
                overflowY: "hidden",
                display: "block",
              }}>
              <div className="flex end-item">
                <AddRestrictedFile />
                <AddRestrictedWords />
              </div>
              <div
                className="relative w-6/12 text-ternary focus-within:text-secondary smallscreen-search"
                style={{ marginTop: -35 }}>
                <div
                  className={classNames(
                    language == "en" ? "left-0 " : "right-0",
                    "absolute inset-y-0 flex items-center pointer-events-none px-1"
                  )}>
                  <SearchIcon className="h-5 w-5" aria-hidden="true" />
                </div>
                <input
                  id="search-field"
                  className={classNames(
                    language == "en" ? "pl-8 pr-3" : "pr-8 pl-3",
                    "block lg:w-6/12 xs:w-full sm:w-full h-full  py-2 border-transparent text-secondary placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm rounded-md"
                  )}
                  placeholder={LocaleStrings.search}
                  type="search"
                  name="search"
                  // onChange={(e) =>
                  //   this.setState({ customerSearchText: e.target.value })
                  // }
                  value={this.state.search}
                  onChange={this.handleSearch}
                />
              </div>
              <div className="panel-body mt-6">
                {/* <TableContent /> */}
                <div className="flex flex-col">
                  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-custWhite">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Prohibited Word
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Prohibited Word File
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider end-item mr-20">
                                {LocaleStrings.action}
                              </th>
                            </tr>
                          </thead>
                          <tbody>{this.renderwordList()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                activePage={this.state.pageNumber}
                itemsCountPerPage={7}
                totalItemsCount={this.props.globalRestrictedWords.count}
                pageRangeDisplayed={10}
                onChange={this.paginationCallback}
              />
              <NotificationContainer />
            </div>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, language } = state;

  return {
    session,
    user,
    language,
    globalRestrictedWords: state.globalRestrictedWords,
  };
}

export default connect(mapStateToProps, {
  fetchRestrictedWords,
  searchRestrictedwords,
})(ContentManagement);
